$('#site-map').masonry({
  // options...
  itemSelector: '.sitemap-section',
});

// $('#site-map').on('transitionend webkitTransitionEnd oTransitionEnd', function () {
//     $('#site-map').masonry({
// 	  // options...
// 	  itemSelector: '.sitemap-section',
// 	  columnWidth: $('#site-map').width() / 3,
// 	});
// });
